import { Component, OnInit } from '@angular/core';

import { AboutService } from './../../services/about.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  titular: any;

  constructor(private aboutService: AboutService) {

    this.titular = aboutService.titular;
    console.log(this.titular);

   }

  ngOnInit(): void {
  }

}
